import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectUserInfo } from '@/store/api/Users/Users.selector'

import { ReportLanguagePopUp } from './ReportLanguagePopUp'

export const ReportLanguage = () => {
  const { t } = useTranslation()
  const { pdfLanguage } = useSelector(selectUserInfo)
  const [openReportSetup, setOpenReportSetup] = useState(false)

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <p className="text-neutralColor text-xl font-medium">
          {t('dashboard.settings.reportSettings.reportLanguage')}
        </p>
        <ReportLanguagePopUp
          currentLang={pdfLanguage}
          open={openReportSetup}
          setOpen={setOpenReportSetup}
        />
      </div>
      <p className="text-dynamicBlue text-base font-bold">
        {t('dashboard.settings.reportSettings.defaultReportLanguage')}{' '}
        {pdfLanguage === 'en'
          ? t('dashboard.settings.english')
          : t('dashboard.settings.spanish')}
      </p>
    </div>
  )
}
